// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideSettings as RawLucideSettings } from "lucide-react";
export const LucideSettings = /* @__PURE__ */ createIcon(RawLucideSettings, "LucideSettings", 2);
